/**
 * @fileoverview Contexto responsável por manter o ticket atual e sincronizar sua navegação.
 */

import React, { useState, useEffect, useRef, createContext } from "react";
import { useHistory, useLocation } from "react-router-dom";

const TicketsContext = createContext();

const TicketsContextProvider = ({ children }) => {
	const [currentTicket, setCurrentTicket] = useState({ id: null, code: null });
	const history = useHistory();
	const location = useLocation();
	const lastTicketIdRef = useRef(null);

	// Reset ref when navigating away from /tickets OR back to the list (/tickets without id).
	// Sem isso, voltar para a lista (ex: ESC) mantém o ref e o clique no MESMO ticket é ignorado.
	useEffect(() => {
		const path = location.pathname.replace(/\/+$/, "");
		if (!path.startsWith("/tickets") || path === "/tickets") {
			lastTicketIdRef.current = null;
		}
	}, [location.pathname]);

	useEffect(() => {
		// Only navigate if ticket ID changed to avoid multiple navigations
		if (
			currentTicket.id !== null &&
			currentTicket.id !== lastTicketIdRef.current
		) {
			lastTicketIdRef.current = currentTicket.id;
			history.push(`/tickets/${currentTicket.uuid}`);
		}
	}, [currentTicket, history]);

	return (
		<TicketsContext.Provider
			value={{ currentTicket, setCurrentTicket }}
		>
			{children}
		</TicketsContext.Provider>
	);
};

export { TicketsContext, TicketsContextProvider };
